import { render, staticRenderFns } from "./dynamicTaolijin.vue?vue&type=template&id=1122a63d&scoped=true&"
import script from "./dynamicTaolijin.vue?vue&type=script&lang=js&"
export * from "./dynamicTaolijin.vue?vue&type=script&lang=js&"
import style0 from "./dynamicTaolijin.vue?vue&type=style&index=0&id=1122a63d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1122a63d",
  null
  
)

export default component.exports